import { formatDate } from "@/utils/dateUtils"
import "./style.css"
import { useEffect, useState } from "react"
import i18n from "@/langsconfig/i18n"
import { Block, CRIcon, CRRender, Inline } from "@/components/crRender"

export const CombinedRequestCell = ({ main, sub, mainClassName, subClassName }) =>
    <div className='combined-request-cell'>
        <span className={mainClassName}>{main}</span>
        <span className={subClassName}>{sub}</span>
    </div>



export const NameRequestCell = ({ original }) =>
    <CombinedRequestCell main={original.patientName} sub={`# ${original.requestId}`} mainClassName='patient-name' subClassName='patient-id' />


export const CategoryRequestCell = ({ original }) =>
    <CombinedRequestCell main={original.categoryName} sub={original.subCategoryName} mainClassName='category-request-cell' subClassName='sub-category-request-cell' />



export const AttachmentsUploadedCell = ({ original }) =>
    <div className='attachments-uploaded-cell'>
        <CRIcon isRender={!!original.isAttachmentsUploaded} icon={"lucide:badge-check"} className="success-text" />
        <Block isRender={!!!original.isAttachmentsUploaded} className="error-text not-have-files" >
            <CRIcon icon={"lucide:badge-x"} /> <Inline className="error-text">{i18n.t("no-attachments-uploaded")}</Inline>
        </Block>
    </div>

